import React, { Suspense, useEffect } from "react";
import PageSpinner from "./PageSpinner/PageSpinner";



import { useLocation } from "react-router-dom";
// import ErrorBoundary from "antd/lib/alert/ErrorBoundary";
// import { ErrorBoundary } from 'react-error-boundary';





import { setResetInputAnimation, setAddClassInputAnimation } from "../config/Global";

import SomethingWentWrong from "../views/errors/SomethingWentWrong";


import { ErrorBoundary } from 'react-error-boundary';


const ModuleWrap: React.FC<any> = ({ module: Module, ...rest }) => {



  const location = useLocation()

  useEffect(() => {
    setTimeout(() => {
      setResetInputAnimation()
    }, 200);
    return () => {
      setResetInputAnimation(false)
    }
  }, [location]);


  return (
    <Suspense fallback={<PageSpinner />}>

      <ErrorBoundary FallbackComponent={SomethingWentWrong}>

        <div className="mainPageWrap">
          <Module permissions={""} {...rest} />
        </div>
      </ErrorBoundary>
    </Suspense>
  );
};

export default ModuleWrap;
